
import ProductPriceValue from './ProductPriceValue'
import catalogProduct from '~/components/Catalog/mixins/catalog-product'
import ProductFreegoodInfo from '~/components/FreeGoods/ProductFreeGoodInfo'
import productFreeGood from '~/components/FreeGoods/mixins/productFreeGood'

export default {
  name: 'ProductPrice',
  components: { ProductFreegoodInfo, ProductPriceValue },
  mixins: [catalogProduct, productFreeGood],
  props: {
    item: {
      type: Object,
      default() {
        return {}
      },
    },
    productDetailLinkData: {
      type: Object,
      default() {
        return {}
      },
      required: true,
    },
  },
  computed: {
    showTextPrice() {
      const { priceValue } = this
      if (
        (typeof priceValue === 'string' && priceValue.length > 5) ||
        priceValue !== 'N/A'
      )
        return true
      if (typeof priceValue === 'number') return priceValue < 10000
      return false
    },
    priceTextClass() {
      return (this.isZenPriceType || this.isRetailPriceType) &&
        !this.isConnected
        ? 'grayDark_02--text'
        : 'red_03--text'
    },
  },
}
